// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-modalheader_default__3tjln","title":"idt-modalheader_title__yooax","flexEnd":"idt-modalheader_flexend__1ducy","buttonRight":"idt-modalheader_buttonright__2inwo"};